module.exports = __webpack_public_path__ + "img/open-filter-icon.78c9fe46.svg";